<app-common-header></app-common-header>
<main role="main" class="maincnt quest">
  <div class="col-12 text-center webview">
    <!-- <img src="assets/images/eva-icons.svg" width="100" class="signimg" /> -->
  </div>
  <h1
    class="text-center mb-2 signuppadd pt-2 font-semibold"
    style="padding-top: 4.5rem !important"
  >
    Login to your Admin account
  </h1>

  <div class="getbannersect pb-2">
    <div class="sectpad container">
      <div class="col-sm-12 p-0 signupmobile">
        <a _ngcontent-c5="" class="mobclose" href="javascript:void(0);"
          ><img
            _ngcontent-c5=""
            src="assets/images/mobclose.png"
            (click)="closebtn()"
        /></a>
        <div
          class="form-group col-lg-7 col-md-12 col-sm-12 p-0 mb-3 m-auto my-5 py-3 text-center"
        ></div>

        <div
          class="form-group col-lg-7 col-md-12 col-sm-12 p-0 mb-3 m-auto text-center"
        ></div>
        <div
          class="col-lg-4 col-md-12 col-sm-12 p-0 mb-3 m-auto text-center px-3"
        ></div>
        <div class="container mt-4">
          <div class="row">
            <div
              class="pt-3 minvalue m-auto form-group col-lg-4 col-md-4 col-sm-12 p-0 mb-3 m-auto text-center"
            >
              <form
                name="form"
                (ngSubmit)="createAccount($event, f)"
                #f="ngForm"
                novalidate
              >
                <div class="text-center minvalue m-auto">
                  <div class="form-group float-label-control">
                    <label for="email">Email</label>
                    <input
                      type="text"
                      class="form-control inputshadow"
                      name="email"
                      [(ngModel)]="userObj.emailId"
                      #email="ngModel"
                      [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
                      required
                      email
                    />
                    <div *ngIf="invalidEmail" class="invalid-feedback">
                      <div class="posabs font15">Email is required</div>
                      <!-- <div class="posabs" *ngIf="email.errors.email">Please enter a valid email</div> -->
                    </div>
                  </div>
                  <div class="form-group float-label-control mb-0">
                    <div class="d-flex flex-row">
                      <div
                        class="col-12 p-0 position-relative"
                        style="width: 90%"
                      >
                        <div class="form-group float-label-control">
                          <label for="password">Password</label>
                          <input
                            class="form-control inputshadow"
                            name="password"
                            [(ngModel)]="userObj.password"
                            #password="ngModel"
                            type="{{ user_bot ? 'text' : 'password' }}"
                            [ngClass]="{
                              'is-invalid': f.submitted && password.invalid
                            }"
                            required
                            minlength="8"
                            pattern="(?=.*\d)(?=.*[!@#$%.^&*])(?=.*[A-Z]).{8,}"
                          />
                        </div>
                        <div class="invalid-feedback posabs">
                          <div>
                            <div
                              class="boxcolour"
                              *ngIf="
                                f.submitted &&
                                password.invalid &&
                                password.errors &&
                                password.errors.required
                              "
                            >
                              <span
                                _ngcontent-c8=""
                                class="fa fa-exclamation-circle mr-1"
                                type="Icon"
                              ></span>
                              Password is required
                            </div>
                            <div
                              [hidden]="
                                password.valid ||
                                password.pristine ||
                                !password.errors.pattern
                              "
                              class="boxcolour"
                              style="line-height: 80%"
                            >
                              <span
                                _ngcontent-c8=""
                                class="fa fa-exclamation-circle mr-1"
                                type="Icon"
                              ></span>
                              Password should contain at least 8 characters with
                              1 Uppercase, 1 special character and 1 number
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="float-right"
                        style="width: 10%"
                        *ngIf="userObj.password"
                      >
                        <i
                          *ngIf="user_bot"
                          (click)="toggleShowPassword(userObj.password)"
                          id="toggleId"
                          class="fa fa-eye"
                          style="cursor: pointer"
                        ></i>
                        <i
                          *ngIf="!user_bot"
                          (click)="toggleShowPassword(userObj.password)"
                          id="toggleId"
                          class="fa fa-eye-slash"
                          style="cursor: pointer"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="form-group col-lg-5 col-md-8 col-sm-4 p-0 mb-3 m-auto text-left pl-2"> -->
                <div class="text-left minvalue m-auto"></div>
                <div class="text-left minvalue m-auto">
                  <a
                    class="forgbtn font18"
                    href="javascript:void(0)"
                    data-toggle="modal"
                    data-target="#forgotModal"
                    (click)="showForgotModal()"
                  >
                    forgot password?</a
                  >
                </div>
                <div class="minvalue text-center">
                  <button class="btn sectbtn signinpad mt-4 minvalue">
                    SUBMIT
                  </button>
                </div>

                <div class="text-center"></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<app-forgot-password
  [forgotVisible]="forgotModalVisible"
  (closeForgotModalEvent)="onClose($event)"
></app-forgot-password>
<!--validation error modal-->
<ng-template #errorStatus4CE>
  <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="goToHomeClose()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img
              src="assets/images/editchart-close.svg"
              width="17"
              style="margin-top: -10px"
            />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        User access denied
      </h4>
      <p class="text-center">
        If you find this message in error, <br />please X out of this and try
        again.
      </p>
      <div class="text-center mt-3 mb-3">
        <img src="assets/images/signkey.png" width="150" />
      </div>
      <div class="text-center">
        <button
          type="button"
          class="btn sectbtn text-uppercase"
          (click)="goToHome()"
        >
          Go to home page
        </button>
      </div>
    </div>
  </div>
</ng-template>
